import Footer from 'components/Footers/Footer';
import Navbar from 'components/Navbars/AdminNavbar';
import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router-dom';
import BASE_URL from 'components/BaseUrl/apiConfig';
import useData from 'rsuite/esm/InputPicker/hooks/useData';

const UpdateAdminProfile = ({ location }) => {
    const history = useHistory();

    const storedUserData = localStorage.getItem('userData');
    let userId = '';

    if (storedUserData) {
        const userData = JSON.parse(storedUserData);
        userId = userData.userId;
    }


    const { userData } = location.state;
    
    const [formData, setFormData] = useState({
        fullname: userData.fullName,
        contactNumber: userData.contact,
        email: userData.emailId,
    });

    const [validationMessages, setValidationErrors] = useState({
        fullname: '',
        contactNumber: '',
        email: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
        setValidationErrors((prevErrors) => ({
            ...prevErrors,
            [name]: '', // Clear the validation error when the user types
        }));
    };

    const validateForm = () => {
        let isValid = true;
        const newErrors = {};

        // Perform validation logic for each field
        if (formData.fullname.trim() === '') {
            newErrors.fullname = 'Full name is required.';
            isValid = false;
        }

        if (formData.contactNumber.trim() === '') {
            newErrors.contactNumber = 'Contact number is required.';
            isValid = false;
        }

        if (formData.email.trim() === '') {
            newErrors.email = 'Email address is required';
            isValid = false;
        } else if (!isValidEmail(formData.email)) {
            newErrors.email = 'Email address is not valid.';
            isValid = false;
        }

        setValidationErrors(newErrors);
        return isValid;
    };

    const isValidEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault(); // Prevent default form submission

        if (!validateForm()) {
            return;
        }

        try {
            const response = await fetch(`${BASE_URL}/api/Users/UpdateAdminProfile`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    userId: userId,
                    fullname: formData.fullname,
                    email: formData.email,
                    contact: formData.contactNumber
                }),
            });

            if (response.ok) {
                const data = await response.json();

                setFormData({
                    fullname: '',
                    email: '',
                    contactNumber: ''
                });

                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: data.msg,
                });
                history.push('/adminDetails');
            } else {
                const errorData = await response.json();
                Swal.fire({
                    icon: 'error',
                    title: 'Failed',
                    text: errorData.msg,
                });
            }
        } catch (error) {
            console.error('Error updating profile:', error.message);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.message,
            });
        }
    };

    const BackToUserDetails = () => {
        history.push('/adminDetails');
    };

    return (
        <>
            <Navbar />
            <div className='cust-div'>
                <div className="container mx-auto p-4 h-full">
                    <div className="flex content-center items-center justify-center h-full">
                        <div className="w-full lg:w-6/12 px-4">
                            <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white border-0">
                                <div className="rounded-t mb-0 px-6 py-3">
                                    <div className="text-center mb-3">
                                        <h1 className="text-2xl font-bold">
                                            Update Your Profile
                                        </h1>
                                    </div>
                                    {/* <hr className="mt-6 border-b-1 border-blueGray-300" /> */}
                                </div>
                                <div className="flex-auto px-4 lg:px-10 py-3 pt-0">
                                    <form onSubmit={handleFormSubmit}>
                                        {/* FullName Input */}
                                        <div className="relative w-full mb-3">
                                            <label
                                                className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                                                htmlFor="fullname"
                                            >
                                                Full Name
                                            </label>
                                            <input
                                                type="text"
                                                id="fullname"
                                                name="fullname"
                                                value={formData.fullname}
                                                onChange={handleChange}
                                                className="border rounded w-full"
                                                placeholder="Full Name"
                                            />
                                            <div className="text-red-500 text-xs mt-1">
                                                {validationMessages.fullname}
                                            </div>
                                        </div>

                                        {/* Email Input */}
                                        <div className="relative w-full mb-3">
                                            <label
                                                className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                                                htmlFor="email"
                                            >
                                                Email
                                            </label>
                                            <input
                                                type="text"
                                                id="email"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                className="border rounded w-full"
                                                placeholder="Email Address"
                                            />
                                            <div className="text-red-500 text-xs mt-1">
                                                {validationMessages.email}
                                            </div>
                                        </div>

                                        {/* Contact Number Input */}
                                        <div className="relative w-full mb-3">
                                            <label
                                                className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                                                htmlFor="contactNumber"
                                            >
                                                Contact Number
                                            </label>
                                            <input
                                                type="text"
                                                id="contactNumber"
                                                name="contactNumber"
                                                value={formData.contactNumber}
                                                onChange={(e) => {
                                                    // Use a regular expression to allow only numeric values
                                                    const numericValue = e.target.value.replace(/[^0-9]/g, '');
                                                    // Update the state with the numeric value
                                                    setFormData({ ...formData, contactNumber: numericValue });
                                                }}
                                                className="border rounded w-full"
                                                placeholder="Contact Number"
                                            />
                                            <div className="text-red-500 text-xs mt-1">
                                                {validationMessages.contactNumber}
                                            </div>
                                        </div>

                                        <div className="flex items-center justify-between mt-6">
                                            <div className="flex justify-end space-x-4 w-full">
                                                <button
                                                    type="button"
                                                    className="bg-lightBlue-500 text-white active:bg-lightBlue-600 text-xs font-bold uppercase px-4 py-2 mr-3 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                                                    onClick={BackToUserDetails}
                                                >
                                                    Back to Profile
                                                </button>
                                                <button
                                                    className="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-3 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none sm:w-auto ease-linear transition-all duration-150"
                                                    type="submit"
                                                >
                                                    Save
                                                </button>
                                            </div>
                                        </div>

                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default UpdateAdminProfile;
